import { FieldBase } from '@/components/form';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Label, Switch } from '@e2n/ui';
import { useTranslation } from 'react-i18next';

export function Guttage() {
  const { ctx } = useAnlageassistentContext();
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  return (
    <div className="flex flex-col gap-6 md:gap-4">
      <div className="flex flex-col gap-3">
        <h2 className="text-neutrals-900 text-xl font-bold leading-7 flex items-center gap-1">
          {ctx.getCurrentSubStep()?.title}
        </h2>
        <span className="text-neutrals-800 text-sm font-normal leading-5">
          {t('domain.mitarbeiter.create.steps.abwesenheiten.guttage.info')}
        </span>
      </div>
      <form.AppField name="abwesenheiten.guttage.guttageBewerten">
        {(field) => (
          <FieldBase>
            <div className="flex gap-2 items-center">
              <Switch
                id={field.name}
                name={field.name}
                checked={field.state.value}
                onCheckedChange={field.handleChange}
                onBlur={field.handleBlur}
              />
              <Label
                htmlFor={field.name}
                className="text-neutrals-900 text-sm font-normal leading-5">
                {t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.guttage.form.guttageBewerten.label',
                )}
              </Label>
            </div>
          </FieldBase>
        )}
      </form.AppField>
    </div>
  );
}
